import { ReactElement } from 'react';

import { FilterPanel } from '@dreryk/react-components';

import { PatientFilterPanelFormBean } from './PatientFilterPanel.types';
import { PatientFilterPanelLoader } from './PatientFilterPanel.loader';
import { PatientGroupsController } from './controllers/patientGroups/PatientGroupsController';

export const PatientFilterPanel = (): ReactElement => (
   <PatientFilterPanelLoader>
      {({ patientGroups }) => (
         <FilterPanel<PatientFilterPanelFormBean> testId={'waitlistFilterPanel'}>
            {({ registerController }) => (
               <>
                  <PatientGroupsController registerController={registerController} patientGroups={patientGroups} />
               </>
            )}
         </FilterPanel>
      )}
   </PatientFilterPanelLoader>
);
